module.exports = __webpack_public_path__ + "img/bg-lg-31.13865c79.jpg";